import { Heading, Text } from 'components/typography';
import Button from 'components/button';
import { Box, Flex } from 'components/box';
import { Check as CheckIcon } from 'react-feather';
import { css } from '@emotion/react';
import dynamic from 'next/dynamic';

const Modal = dynamic(() => import('components/_shared/widgets/modal'));

const SuccessModal = ({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) => (
  <Modal isOpen={isOpen} close={close} size="small">
    <Box
      p={[4, null, 5]}
      css={css`
        text-align: center;
      `}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        py={2}
        borderRadius="100%"
        width="140px"
        height="140px"
        mx="auto"
        backgroundColor="lightLime"
        css={theme => css`
          border: 1px solid ${theme.colors.lime};
        `}
      >
        <CheckIcon
          size={95}
          css={theme => css`
            color: ${theme.colors.lime};
          `}
        />
      </Flex>

      <Heading textAlign="center" mt={4}>
        Thank you for submitting your application.
      </Heading>

      <Text lineHeight={1.7} textAlign="center" my={2}>
        One of our team members will be in touch. Should you not receive any
        feedback within 2 weeks, please deem the application unsuccessful.
      </Text>

      <Button onClick={() => close()} my={2} mx="auto">
        Continue
      </Button>
    </Box>
  </Modal>
);

export default SuccessModal;
